import React, { useRef, useState } from 'react';
import CusPageCardContainer from '../../../components/shared/CusPageCardContainer';
import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IconMenu } from '@tabler/icons-react';
import useBootstrapSize from '../../../hooks/useBootstrapSize';
import AddNewUserBtn from './mui/AddNewUserBtn';
import AddNewUser from '../modal/AddNewUser';
import UserListContent from './UserListContent';

export default function UsersList() {
  const { t } = useTranslation();
  const { isLessTablet, isMobile } = useBootstrapSize();

  const [openMobileMenu, setOpenMobileMenu] = useState(!isMobile);
  const [openAddUser, setOpenAddUser] = useState(false);
  const [defaultSelectGroupId, setDefaultSelectGroupId] = useState();

  return (
    <>
      <CusPageCardContainer
        headTitle={'Users'}
        title={
          <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
            <Typography variant="h5">{t('Users')}</Typography>

            {isLessTablet ? (
              <Button onClick={() => setOpenMobileMenu((prev) => !prev)} sx={{ p: 0.5 }}>
                <IconMenu />
              </Button>
            ) : (
              <AddNewUserBtn onClick={() => setOpenAddUser(true)} />
            )}
          </Stack>
        }>
        <UserListContent
          openMobileMenu={openMobileMenu}
          setDefaultSelectGroupId={setDefaultSelectGroupId}
          setOpenMobileMenu={setOpenMobileMenu}
        />
      </CusPageCardContainer>

      <AddNewUser
        open={openAddUser}
        closeModal={() => setOpenAddUser(false)}
        defaultSelectGroupId={defaultSelectGroupId}
      />
    </>
  );
}
